import type { PostLoginTranslations } from './types';

export const a11yTranslations = {
  'a11y.action.editModeration': { es: 'Editar configuración de Moderación', en: 'Edit Moderation settings' },
} satisfies PostLoginTranslations;
